import { SellingConditionEnum } from '@newModels';
import { ProductDetailsSellerMethods, ProductDetailsSellerMethodsSkeleton } from '@components/product/ProductDetailsSellerMethods';

import { useProductDetailsSellerMethodsQuery } from './gql/graphql.v4.generated';

interface Props {
  className?: string,
  productId: number,
}

export const ProductDetailsSellerMethodsContainer: React.FC<Props> = ({
  className,
  productId,
}) => {
  const { data, loading } = useProductDetailsSellerMethodsQuery({
    variables: { productId },
    context: {
      v4: true,
    },
  });

  const isSwap = data?.product?.sellingCondition === SellingConditionEnum.Exchange;

  if (isSwap) {
    return null;
  }

  if (loading) {
    return (
      <ProductDetailsSellerMethodsSkeleton className={className} />
    );
  }

  if (data?.product) {
    return (
      <ProductDetailsSellerMethods
        className={className}
        deliverySettings={data.product.seller?.deliverySettings}
        paymentMethods={data.product.seller?.paymentMethods}
        isReturnEnabled={data.product.isReturnEnabled}
      />
    );
  }
  
  return null;
};
